import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  removeItem(arg0: string) {
    throw new Error('Method not implemented.');
  }

  constructor() {

  }

getStore(name: string) {
  if (!name) {
    return;
  }
  return localStorage.getItem(name) || "";
}

setStore(name: string, content: any) {
  if (!name) {
    return;
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  localStorage.setItem(name, content);
}

removeStore(name: string) {
  if (!name) {
    return;
  }
  localStorage.removeItem(name);
}

public clearData() {
  localStorage.clear();
}


getItem(key: string): any {
  const data = localStorage.getItem(key);
  if (!data) return null; 
  try {
    console.log('Dataaa',data);
    return JSON.parse(data);
  } catch (error) {
    console.error(`JSON parse hatası: ${'rror.message'}`, data);
    return null;
  }
}

  setItem(key: string, value: any): void {
  localStorage.setItem(key, JSON.stringify(value));
}
  getDashboard<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
}
